import { createClient } from '@supabase/supabase-js';
import config from './environment';

// Use fallback values to prevent crashes when environment variables are missing
const supabaseUrl = config.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = config.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    }
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
}); 